// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"a428617d","977":"40764226"}[chunkId] + ".chunk.js");